<template>
	<div
		class="container__loading"
		role="status"
	>
		<div class="container__loading__animation" />
	</div>
</template>

<script>
export default {}
</script>

<style>
.container__loading {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.container__loading__animation {
	border-radius: 50%;
	height: 20px;
	width: 20px;
	border: 1px solid rgba(var(--color-default), 0.5);
	border-top: 3px solid rgb(var(--color-default));
	animation: anima__loading 0.5s linear infinite;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.container__loading__animation {
		height: 15px;
		width: 15px;
	}
}

@keyframes anima__loading {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
